import React from "react";
import Greetingcards from "../../assets/pic/4greetingcards.svg";
import Notifications from "../../assets/pic/Notifications.svg";
import calendar from "../../assets/pic/calendar.svg";
import Mailed from "../../assets/pic/Mailed.svg";
import { LayoutForLandingPage } from "./Home";

const Features = () => {
  return (
    <LayoutForLandingPage>
      <div className="flex justify-center">
        <div className="py-6 flex flex-col justify-center max-w-7xl">
          <h2 className="lg:text-5xl mt-4 text-3xl font-bold leading-tight text-center">
            What do <span className="text-[#F66061]">you get?</span>
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mt-8 gap-8">
            {/* Icon 1 */}
            <div className="flex flex-col items-center text-center">
              {/* <div className="bg-[#F1E3E4] rounded-full h-[50px] w-[50px]"> */}
                <img
                  src={Greetingcards}
                  alt="Greeting cards"
                  className="w-24 h-24 object-contain mb-2"
                />
              {/* </div> */}
              <div className="text-xl md:text-2xl font-semibold font-shadows mb-1">4 Greeting Cards</div>
              <p className="text-gray-600">
                4 physical greeting cards every month with custom messages built
                from your recipients' profile.
              </p>
            </div>

            {/* Icon 2 */}
            <div className="flex flex-col items-center text-center">
              {/* <div className="bg-[#F1E3E4] rounded-full p-4 mb-4"> */}
                <img
                  src={Notifications}
                  alt="Notifications"
                 className="w-24 h-24 object-contain mb-2"
                />
              {/* </div> */}
              <div className="text-xl md:text-2xl font-semibold font-shadows mb-1">Calendar View</div>
              <p className="text-gray-600">
                A calendar view that shows all upcoming occasions for every
                month.
              </p>
            </div>

            {/* Icon 3 */}
            <div className="flex flex-col items-center text-center">
              {/* <div className="bg-[#F1E3E4] rounded-full p-4 mb-4"> */}
                <img
                  src={calendar}
                  alt="Calendar"
                className="w-24 h-24 object-contain mb-2"
                />
              {/* </div> */}
              <div className="text-xl md:text-2xl font-semibold font-shadows mb-1">Notification Reminders</div>
              <p className="text-gray-600">
                Receive notification reminders of upcoming events, so you never
                miss a special moment.
              </p>
            </div>

            {/* Icon 4 */}
            <div className="flex flex-col items-center text-center">
              {/* <div className="bg-[#F1E3E4] rounded-full p-4 mb-4"> */}
                <img
                  src={Mailed}
                  alt="Mailed"
                  className="w-24 h-24 object-contain mb-2"
                />
              {/* </div> */}
              <div className="text-xl md:text-2xl font-semibold font-shadows mb-1">Mailed Cards</div>
              <p className="text-gray-600">
                We mail the greeting cards you pick directly to your recipient!
              </p>
            </div>
          </div>
        </div>
      </div>
    </LayoutForLandingPage>
  );
};

export default Features;
